// extracted by mini-css-extract-plugin
export default {"withdrawForm":"Withdraw_withdrawForm__xSUOI"};